<div class="row"
  id="comments-section">
  <div [class]="'col-12 ' + customOptions?.alignIconDiv">
    <button class="comment-btn"
      mat-icon-button
      [pTooltip]="'forms.common.' + customOptions?.btnConfig?.tooltip | translate"
      [tooltipPosition]="customOptions?.btnConfig?.tooltipPosition"
      (click)="showDialog()">
      <mat-icon class="comments-icon">{{ customOptions?.btnConfig?.icon }}</mat-icon>
    </button>

    <mat-divider></mat-divider>
  </div>
</div>
